'use client';

import type { ShopifyAnalyticsProduct } from '@shopify/hydrogen-react';
import { createContext, useContext } from 'react';

export type { ShopifyAnalyticsProduct };

export type ShopifyAddToCartEvent = {
   cartId: string;
   products: ShopifyAnalyticsProduct[];
   totalValue: number;
};

export const ShopifyAddToCartTrackerContext = createContext<
   ((event: ShopifyAddToCartEvent) => void) | null
>(null);

export function useShopifyAddToCartTracker() {
   return useContext(ShopifyAddToCartTrackerContext);
}
